import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Button from "components/basic/button";
import Card from "components/basic/card";
import { headerOffset } from "components/basic/header";
import Typography from "components/basic/typography";
import { SignInData } from "../..";
import RequestCodeStep from "./components/RequestCodeStep";
import ResetStep from "./components/ResetStep";

interface ForgotPasswordProps {
  signInData: SignInData;
  setSignInData: React.Dispatch<React.SetStateAction<SignInData>>;
}

/** Resets a forgotten password with a code sent to the login email. */
const ForgotPassword: React.FC<ForgotPasswordProps> = ({
  signInData,
  setSignInData,
}) => {
  const theme = useTheme();
  const { t } = useTranslation("auth");
  const navigate = useNavigate();
  const [codeSent, setCodeSent] = useState(false);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: `calc(100vh - ${headerOffset(1)})`,
        padding: `0 ${theme.spacing(2)}`,
      }}
    >
      <div style={{ width: "100%", maxWidth: "550px" }}>
        <Card disableVerticalPadding square dark>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: theme.spacing(2),
              padding: `${theme.spacing(1.5)} ${theme.spacing(4)}`,
            }}
          >
            <Typography variant="h4" align="center">
              {t("forgot.title")}
            </Typography>

            {codeSent ? (
              <ResetStep
                email={signInData.email}
                onReset={() => {
                  setSignInData((prev) => ({ ...prev, password: "" }));
                  navigate("?currentPage=signInForm");
                }}
                onResend={() => setCodeSent(false)}
              />
            ) : (
              <RequestCodeStep
                email={signInData.email}
                onEmailChange={(email) =>
                  setSignInData((prev) => ({ ...prev, email }))
                }
                onSent={() => setCodeSent(true)}
              />
            )}

            <Button
              onClick={() => navigate("?currentPage=signInForm")}
              variant="text"
              size="small"
              style={{ color: theme.palette.common.white }}
            >
              {t("forgot.back")}
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ForgotPassword;
